import {inject, Injectable} from '@angular/core';
import {CorporateFormsService} from '../corporate/services/corporate-forms.service';
import {FormTypeEnum} from '../corporate/enums/form-type.enum';
import {Observable} from 'rxjs';
import {of} from 'rxjs/internal/observable/of';
import {IFormService} from '../corporate/models/IFormService.interface';
import {ILegacyCustomer} from '../pluton-invoicing-module/components/legacy-customers';

@Injectable({
  providedIn: 'root'
})
export class InvoicingClientService {

  private readonly corporateService = inject(CorporateFormsService);

  get invoicingClient(): {
    clientId: number;
    formType: number,
    individual_businessId: number,
    client_name: string,
    client_code: string,
    appartment:string,
    buildingName:string,
    buildingNum:string,
    floor:string,
    city:string,
    country:string,
    houseNum:string,
    postcode:string,
    state:string,
    street:string,
    zip:string,
    plutosCustomerId?: string
  } {
    return JSON.parse(localStorage.getItem('invoicingClient'));
  }

  /**
   * Get the Plutos customer ID for the current invoicing client
   * Returns null if not linked to a Plutos customer
   */
  get plutosCustomerId(): string | null {
    return this.invoicingClient?.plutosCustomerId || null;
  }

  /**
   * Check if the current invoicing client has a linked Plutos customer
   */
  get hasPlutosCustomer(): boolean {
    return !!this.invoicingClient?.plutosCustomerId;
  }

  /**
   * Update the Plutos customer ID for the current invoicing client
   */
  setPlutosCustomerId(plutosCustomerId: string): void {
    const client = this.invoicingClient;
    if (client) {
      client.plutosCustomerId = plutosCustomerId;
      localStorage.setItem('invoicingClient', JSON.stringify(client));
    }
  }

  setClientName(name: string): void {
    const client = this.invoicingClient;
    if (client) {
      client.client_name = name;
      localStorage.setItem('invoicingClient', JSON.stringify(client));
    }
  }

  getClientServices(): Observable<IFormService[]> {
    const client = this.invoicingClient;
    if (!client || client.formType == null || !client.individual_businessId) {
      return of([]);
    }
    return this.defineClientType<IFormService[]>(
      client.formType,
      this.corporateService.getIndividualServices(client.individual_businessId),
      this.corporateService.getBusinessServices(client.individual_businessId),
    );
  }

  private defineClientType<T>(formType: FormTypeEnum, individualRequest: Observable<T>, businessRequest: Observable<T>): Observable<T> {
    switch (formType) {
      case FormTypeEnum.Individual:
        return individualRequest;
      case FormTypeEnum.Business:
        return businessRequest;
      default:
        return of([] as unknown as T);
    }
  }

  // Legacy Client

  getLegacyClient(): ILegacyCustomer {
    const parsed = JSON.parse(localStorage.getItem('legacyInvoicingClient'));
    return parsed;
  }

  setLegacyClient(legacyClient: ILegacyCustomer): void {
    localStorage.setItem('legacyInvoicingClient', JSON.stringify(legacyClient));
  }

}
